import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { token, refreshUser } = useAuth();
    const [transaction, setTransaction] = useState(null);
    const [loading, setLoading] = useState(true);

    const orderId = searchParams.get('orderId');

    useEffect(() => {
        const checkStatus = async () => {
            if (!orderId || !token) {
                setLoading(false);
                return;
            }
            try {
                const res = await axios.get(`${API_URL}/payment/status/${orderId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setTransaction(res.data);
                if (refreshUser) refreshUser();
            } catch (err) {
                console.error('Erreur vérification paiement:', err);
            } finally {
                setLoading(false);
            }
        };
        checkStatus();
    }, [orderId, token, refreshUser]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
            <Paper sx={{ p: 5, textAlign: 'center', maxWidth: 450, borderRadius: 3 }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
                <Typography variant="h4" gutterBottom fontWeight="bold">
                    Paiement réussi
                </Typography>
                {transaction && (
                    <>
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                            {transaction.points} points crédités
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Montant : {transaction.amount} TND
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Réf : {transaction.orderId}
                        </Typography>
                    </>
                )}
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/dashboard')}
                    sx={{ mt: 2 }}
                >
                    Retour au tableau de bord
                </Button>
            </Paper>
        </Box>
    );
}

export default PaymentSuccess;
